import React from 'react';
import EnergyMeterBanner from './EnergyMeterBanner';
import EnergyMeterPrompt from './EnergyMeterPrompt';
import EnergyMeterPopover from './EnergyMeterPopover';

const EnergyMeterViewerOverlay = ({ energyMeter, processId }) => {
  if (!energyMeter || !energyMeter.active) return null;

  return (
    <>
      <EnergyMeterBanner
        mode={energyMeter.mode}
        setMode={energyMeter.setMode}
        majorVersion={energyMeter.majorVersion}
        processVersion={energyMeter.processVersion}
        totalRatings={energyMeter.totalRatings}
        hotspotCount={energyMeter.hotspotCount}
        isHistorical={energyMeter.isHistorical}
      />

      {energyMeter.promptActivity && (
        <EnergyMeterPrompt
          processId={processId}
          activityId={energyMeter.promptActivity.id}
          activityTitle={energyMeter.promptActivity.title}
          version={energyMeter.processVersion}
          onClose={energyMeter.closeOverlays}
          onSubmitted={() => {
            energyMeter.refreshStats();
            energyMeter.closeOverlays();
          }}
          style={{
            bottom: '80px',
            right: '24px',
          }}
        />
      )}

      {energyMeter.popoverActivity &&
        (() => {
          const popoverId = energyMeter.popoverActivity.id;
          const activityStats = energyMeter.stats?.activities
            ? energyMeter.stats.activities[popoverId] ||
              energyMeter.stats.activities[String(popoverId)] ||
              energyMeter.stats.activities[Number(popoverId)]
            : undefined;
          return (
            <EnergyMeterPopover
              activityId={popoverId}
              activityTitle={energyMeter.popoverActivity.title}
              activityStats={activityStats}
              majorVersion={energyMeter.majorVersion}
              processVersion={energyMeter.processVersion}
              onClose={energyMeter.closeOverlays}
            />
          );
        })()}
    </>
  );
};

export default EnergyMeterViewerOverlay;
